import { Component, OnInit } from '@angular/core';
import { ModalController } from "@ionic/angular";
import { UTILITIES } from "../../core/utility/utilities";

@Component({
  selector: 'app-nutri-select-slot',
  templateUrl: './nutri-select-slot.component.html',
  styleUrls: ['./nutri-select-slot.component.scss'],
})
export class NutriSelectSlotComponent implements OnInit {
  guranteeData;
  isIos =  this.utilities.isDeviceiOS();
  foodSlots = [
    {
      name: "Breakfast",
      value: 2,
      isSelected: true
    },{
      name: "Morning Snacks",
      value: 3,
      isSelected: false
    },{
      name: "Lunch",
      value: 4,
      isSelected: false
    },{
      name: "Evening Snacks",
      value: 6,
      isSelected: false
    },{
      name: "Dinner",
      value: 7,
      isSelected: false
    }
  ]
  constructor(public modalController: ModalController,
    private utilities: UTILITIES,) { }

  ngOnInit() {}

  close(flag) {
    if(flag){
      let selectedSlot = this.foodSlots.filter((ele,i)=>{
        return ele.isSelected;
      });
      if(selectedSlot && selectedSlot.length > 0){
        let data = {
          selectedSlot : selectedSlot[0].value
        }
        this.modalController.dismiss(data);
      }else this.modalController.dismiss();
    }else{
      this.modalController.dismiss();
    }
  }

  slotSelected(slot,index){
    if(!slot["isSelected"]){
      this.foodSlots.filter((ele,i)=>{
        if(i == index){
            ele["isSelected"] = true;
        }else{
          ele["isSelected"] = false;
        }
        return ele;
      });
    }else{
      this.foodSlots.filter((ele,i)=>{
        ele["isSelected"] = false;
        return ele;
      });
    }
  }
}

